import LazyComponent from './LazyComponent';
import LazyLoader from './LazyLoader';

export { LazyComponent, LazyLoader };
